import { getFontStack } from '../../../config';
import { withAlpha } from '../../../utils/color';

const LOOK_PREVIEW_SIZE = 15;

export const getPreviewStyle = (preset, previewSize = preset.previewSize || LOOK_PREVIEW_SIZE) => {
  const { style = {}, letterSpacingEm, background, shadow, outline } = preset;
  const css = {
    fontFamily: getFontStack(style.fontFamily || 'Inter'),
    fontSize: previewSize,
    fontWeight: style.bold ? 700 : 400,
    fontStyle: style.italic ? 'italic' : 'normal',
    color: style.fill || '#111111',
  };
  if (letterSpacingEm) {
    css.letterSpacing = `${letterSpacingEm}em`;
  }
  if (background) {
    css.background = background.opacity == null ? background.fill : withAlpha(background.fill, background.opacity);
    css.padding = `${background.paddingEm}em`;
    css.borderRadius = `${background.radiusEm}em`;
    if (background.blurEm) {
      css.backdropFilter = `blur(${background.blurEm * previewSize}px)`;
    }
  }
  if (shadow) {
    const offset = previewSize * shadow.offsetEm;
    css.textShadow = `${offset}px ${offset}px ${previewSize * shadow.blurEm}px ${withAlpha(
      shadow.color,
      shadow.opacity,
    )}`;
  }
  if (outline) {
    css.WebkitTextStroke = `${Math.max(1, previewSize * outline.widthEm)}px ${outline.color}`;
    css.paintOrder = 'stroke fill';
  }
  return css;
};
